import React, { useState } from "react";
import { useSearchParams } from "react-router-dom";
import ResourcesPageTitle from "./components/ResourcesPageTitle";
import { Tabs } from "antd";
import "./index.scss";
import FAQ from "./components/Faq/FAQ";
import ReleaseNotes from "./components/ReleaseNotes/ReleaseNotes";

const Resources: React.FC = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const [activeTabKey, setActiveTabKey] = useState<string>(
    searchParams.get("tab") || "faq"
  );

  const handleTabChange = (key: string) => {
    setSearchParams((prev) => {
      const newParams = new URLSearchParams(prev);
      newParams.set("tab", key);
      return newParams;
    });
    setActiveTabKey(key);
  };

  const items = [
    {
      key: "faq",
      label: "FAQ",
    },
    {
      key: "release-notes",
      label: "Release Notes",
    },
  ];

  const renderActiveTabChildren = () => {
    if (activeTabKey === "faq") {
      return <FAQ />;
    }
    if (activeTabKey === "release-notes") {
      return <ReleaseNotes />;
    }
  };

  return (
    <section className="resources-page-container hide-scroll-bar">
      <ResourcesPageTitle />
      <Tabs
        style={{ margin: "0px", width: "100%" }}
        activeKey={activeTabKey}
        items={items}
        onChange={handleTabChange}
        size="small"
      />
      <div className="resources-page-tab-children-wrapper hide-scroll-bar">
        {renderActiveTabChildren()}
      </div>
    </section>
  );
};

export default Resources;
